// @flow
import type {
  ERROR_TYPE,
  COUNTRY_TYPE,
  GEO_POINT_TYPE,
  POINT_TYPE,
  ID_TYPE,
} from './common';

import type { STUDENT_TYPE } from './student';

export type ROUTE_TYPE = {
  id?: number,
  name?: string,
  short_name: string,
  route_type?: 'going' | 'returning',
  expected_departure_time?: number,
  expected_passenger_number?: number,
  expected_completion_time?: number,
  stops?: Array<number>,
  week_days?: Array<number>,
  isWatchingStopsDetail?: boolean,
  monitor?: number,
  driver?: number
};

export type ROUTE_STOP_TYPE = {
  id: number,
  stop_type?: string,
  name?: string,
  short_name?: string,
  address?: string,
  city?: string,
  country?: COUNTRY_TYPE,
  point?: GEO_POINT_TYPE,
  students?: Array<number>,
  week_days?: Array<number>,
  eta?: string,
  eta_distance?: Object,
  route?: number,
  path_to_next_stop?: Array<POINT_TYPE>,
};

export type ROUTE_STUDENT_DESCRIPTION_TYPE = {
  id: number,
  start_stop: ROUTE_STOP_TYPE,
  end_stop: ROUTE_STOP_TYPE,
  pick_or_drop_stop: ROUTE_STOP_TYPE
};

export type ROUTES_FETCH_STARTED_TYPE = {
  type: 'ROUTES_FETCH_STARTED',
  payload: {
    schoolId: number,
  },
};
export const ROUTES_FETCH_STARTED = 'ROUTES_FETCH_STARTED';

export type ROUTES_FETCH_SUCCEED_TYPE = {
  type: 'ROUTES_FETCH_SUCCEED',
  payload: {
    entities: {[number]: ROUTE_TYPE},
    order: Array<number>
  }
};
export const ROUTES_FETCH_SUCCEED = 'ROUTES_FETCH_SUCCEED';

export type ROUTES_UPDATE_SUCCEED_TYPE = {
  type: 'ROUTES_UPDATE_SUCCEED',
  payload: ROUTE_TYPE
};
export const ROUTES_UPDATE_SUCCEED = 'ROUTES_UPDATE_SUCCEED';

export type ROUTES_UPDATE_FAILED_TYPE = {
  type: 'ROUTES_UPDATE_FAILED',
  payload: ERROR_TYPE
};

export const ROUTES_UPDATE_FAILED = 'ROUTES_UPDATE_FAILED';

export type ROUTES_FETCH_FAILED_TYPE = {
  type: 'ROUTES_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const ROUTES_FETCH_FAILED = 'ROUTES_FETCH_FAILED';

export type SORT_STOP_FAILED_TYPE = {
  type: 'SORT_STOP_FAILED',
  payload: ERROR_TYPE
};
export const SORT_STOP_FAILED = 'SORT_STOP_FAILED';

export type CREATE_ROUTE_FAILED_TYPE = {
  type: 'CREATE_ROUTE_FAILED',
  payload: ERROR_TYPE
};
export const CREATE_ROUTE_FAILED = 'CREATE_ROUTE_FAILED_TYPE';

export type ROUTE_SELECTED_TYPE = {
  type: 'ROUTE_SELECTED',
  payload: {
    id: number,
    zoomMap: boolean,
  }
};
export const ROUTE_SELECTED = 'ROUTE_SELECTED';

export type ROUTE_REMOVED_TYPE = {
  type: 'ROUTE_REMOVED',
  payload: number
};

export const ROUTE_DESELECTED = 'ROUTE_DESELECTED';

export type ROUTE_DESELECTED_TYPE = {
  type: 'ROUTE_DESELECTED'
};
export const ROUTE_REMOVED = 'ROUTE_REMOVED';

export type ROUTE_FETCH_STARTED_TYPE = {
  type: 'ROUTE_FETCH_STARTED',
  payload: number
};
export const ROUTE_FETCH_STARTED = 'ROUTE_FETCH_STARTED';

export type ROUTE_FETCH_SUCCEED_TYPE = {
  type: 'ROUTE_FETCH_SUCCEED',
  payload: ROUTE_TYPE
};
export const ROUTE_FETCH_SUCCEED = 'ROUTE_FETCH_SUCCEED';

export type ROUTE_FETCH_FAILED_TYPE = {
  type: 'ROUTE_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const ROUTE_FETCH_FAILED = 'ROUTE_FETCH_FAILED';

export type ROUTE_STOP_FETCH_STARTED_TYPE = {
  type: 'ROUTE_STOP_FETCH_STARTED',
  payload: number
};
export const ROUTE_STOP_FETCH_STARTED = 'ROUTE_STOP_FETCH_STARTED';

export type ROUTE_STOP_FETCH_SUCCEED_TYPE = {
  type: 'ROUTE_STOP_FETCH_SUCCEED',
  payload: ROUTE_STOP_TYPE
};
export const ROUTE_STOP_FETCH_SUCCEED = 'ROUTE_STOP_FETCH_SUCCEED';

export type ROUTE_STOP_FETCH_FAILED_TYPE = {
  type: 'ROUTE_STOP_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const ROUTE_STOP_FETCH_FAILED = 'ROUTE_STOP_FETCH_FAILED';

export type ROUTE_STUDENT_DESCRIPTION_FETCH_SUCCEED_TYPE = {
  type: 'ROUTE_STUDENT_DESCRIPTION_FETCH_SUCCEED',
  payload: {
    routeId: number,
    studentId: number,
    description: ROUTE_STUDENT_DESCRIPTION_TYPE
  }
};
export const ROUTE_STUDENT_DESCRIPTION_FETCH_SUCCEED = 'ROUTE_STUDENT_DESCRIPTION_FETCH_SUCCEED';

export type ROUTE_STUDENT_DESCRIPTIONS_ADDED_TYPE = {
  type: 'ROUTE_STUDENT_DESCRIPTIONS_ADDED',
  payload: {
    studentId: number,
    routeDescriptions: Array<ROUTE_STUDENT_DESCRIPTION_TYPE>
  }
};
export const ROUTE_STUDENT_DESCRIPTIONS_ADDED = 'ROUTE_STUDENT_DESCRIPTIONS_ADDED';

export type ROUTE_STOPS_FETCH_STARTED_TYPE = {
  type: 'ROUTE_STOPS_FETCH_STARTED',
  payload: number
};
export const ROUTE_STOPS_FETCH_STARTED = 'ROUTE_STOPS_FETCH_STARTED';

export type ROUTE_STOPS_FETCH_SUCCEED_TYPE = {
  type: 'ROUTE_STOPS_FETCH_SUCCEED',
  payload: {
    id: number,
    entities: {[number]: ROUTE_STOP_TYPE},
    order?: Array<number>
  }
};
export const ROUTE_STOPS_FETCH_SUCCEED = 'ROUTE_STOPS_FETCH_SUCCEED';

export type UPDATE_VISIBLE_ROUTES_TYPE = {
  type: 'UPDATE_VISIBLE_ROUTES',
  payload: Array<number>

};
export const UPDATE_VISIBLE_ROUTES = 'UPDATE_VISIBLE_ROUTES';

export type UPDATE_STOP_WEEKDAYS_TYPE = {
  type: 'UPDATE_STOP_WEEKDAYS',
  payload: {id: number, week_days: Array<number>}

};
export const UPDATE_STOP_WEEKDAYS = 'UPDATE_STOP_WEEKDAYS';

export type ROUTE_STOPS_FETCH_FAILED_TYPE = {
  type: 'ROUTE_STOPS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const ROUTE_STOPS_FETCH_FAILED = 'ROUTE_STOPS_FETCH_FAILED';

export type ROUTE_UPDATED_TYPE = {
  type: 'ROUTE_UPDATED',
  payload: ROUTE_TYPE
};
export const ROUTE_UPDATED = 'ROUTE_UPDATED';

export type ROUTE_STOP_SELECTED_TYPE = {
  type: 'ROUTE_STOP_SELECTED',
  payload: number
};
export const ROUTE_STOP_SELECTED = 'ROUTE_STOP_SELECTED';

export type ROUTE_STOP_ADDED_TYPE = {
  type: 'ROUTE_STOP_ADDED',
  payload: ROUTE_STOP_TYPE
};
export const ROUTE_STOP_ADDED = 'ROUTE_STOP_ADDED';

export type ROUTE_STOP_REMOVED_TYPE = {
  type: 'ROUTE_STOP_REMOVED',
  payload: number
};
export const ROUTE_STOP_REMOVED = 'ROUTE_STOP_REMOVED';

export type ROUTE_STOPS_DESELECTED_TYPE = {
  type: 'ROUTE_STOPS_DESELECTED'
};
export const ROUTE_STOPS_DESELECTED = 'ROUTE_STOPS_DESELECTED';

export type ROUTE_STOP_UPDATED_TYPE = {
  type: 'ROUTE_STOP_UPDATED',
  payload: ROUTE_STOP_TYPE
};
export const ROUTE_STOP_UPDATED = 'ROUTE_STOP_UPDATED';

export type ROUTE_STOP_STUDENT_ADDED_TYPE = {
  type: 'ROUTE_STOP_STUDENT_ADDED',
  payload: {
    id: number,
    student: STUDENT_TYPE
  }
};
export const ROUTE_STOP_STUDENT_ADDED = 'ROUTE_STOP_STUDENT_ADDED';

export type ROUTE_STOPS_STUDENT_ASSIGNMENT_STARTED_TYPE = {
  type: 'ROUTE_STOPS_STUDENT_ASSIGNMENT_STARTED',

}

export type ROUTE_STOPS_STUDENT_ASSIGN_STARTED_TYPE = {
  type: 'ROUTE_STOPS_STUDENT_ASSIGN_STARTED',
  payload: {
    stops: Array<ROUTE_STOP_TYPE>,
    student: ID_TYPE,
  }
};
export const ROUTE_STOPS_STUDENT_ASSIGN_STARTED = 'ROUTE_STOPS_STUDENT_ASSIGN_STARTED';

export type ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED_TYPE = {
  type: 'ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED',
};
export const ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED = 'ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED';

export type ROUTE_STOPS_STUDENT_ASSIGN_FAILED_TYPE = {
  type: 'ROUTE_STOPS_STUDENT_ASSIGN_FAILED',
  payload: ERROR_TYPE,
};
export const ROUTE_STOPS_STUDENT_ASSIGN_FAILED = 'ROUTE_STOPS_STUDENT_ASSIGN_FAILED';

export type ROUTE_STOP_CONFIRMED_TYPE = {
  type: 'ROUTE_STOP_CONFIRMED',
  payload: {
    oldId: ID_TYPE,
    newId: ID_TYPE
  }
};
export const ROUTE_STOP_CONFIRMED = 'ROUTE_STOP_CONFIRMED';

export type ROUTE_STOP_STUDENTS_FETCH_STARTED_TYPE = {
  type: 'ROUTE_STOP_STUDENTS_FETCH_STARTED',
  payload: number
};
export const ROUTE_STOP_STUDENTS_FETCH_STARTED = 'ROUTE_STOP_STUDENTS_FETCH_STARTED';

export type ROUTE_STOP_STUDENTS_FETCH_SUCCEED_TYPE = {
  type: 'ROUTE_STOP_STUDENTS_FETCH_SUCCEED',
  payload: {
    id: number,
    entities: { [number]: STUDENT_TYPE },
    order: Array<number>
  }
};
export const ROUTE_STOP_STUDENTS_FETCH_SUCCEED = 'ROUTE_STOP_STUDENTS_FETCH_SUCCEED';

export type ROUTE_STOP_STUDENTS_FETCH_FAILED_TYPE = {
  type: ' ROUTE_STOP_STUDENTS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const ROUTE_STOP_STUDENTS_FETCH_FAILED = ' ROUTE_STOP_STUDENTS_FETCH_FAILED';


export type ROUTE_PATH_FETCH_STARTED_TYPE = {
  type: 'ROUTE_PATH_FETCH_STARTED',
  payload: number
};
export const ROUTE_PATH_FETCH_STARTED = 'ROUTE_PATH_FETCH_STARTED';

export type ROUTE_PATH_FETCH_SUCCEED_TYPE = {
  type: 'ROUTE_PATH_FETCH_SUCCEED',
  payload: {
    id: number,
    route_path: Object
  }
};
export const ROUTE_PATH_FETCH_SUCCEED = 'ROUTE_PATH_FETCH_SUCCEED';

export type ROUTE_STOPS_DETAIL_SHOWN_TYPE = {
  type: 'ROUTE_STOPS_DETAIL_SHOWN',
  payload: {
    id: number,
    isWatchingStopsDetail: true
  }
};
export const ROUTE_STOPS_DETAIL_SHOWN = 'ROUTE_STOPS_DETAIL_SHOWN';

export type ROUTE_STOPS_DETAIL_HIDDEN_TYPE = {
  type: 'ROUTE_STOPS_DETAIL_HIDDEN',
  payload: {
    id: number,
    isWatchingStopsDetail: false
  }
};
export const ROUTE_STOPS_DETAIL_HIDDEN = 'ROUTE_STOPS_DETAIL_HIDDEN';


export type CREATE_ROUTE_STARTED_TYPE = {
  type: 'CREATE_ROUTE_STARTED',
  payload: {
    monitor: number,
    driver: number,
    week_days: Array<ID_TYPE>,
    name: string,
    type: string,
    expected_completion_time: string,
    expected_departure_time: string
  }
};
export const CREATE_ROUTE_STARTED = 'CREATE_ROUTE_STARTED';


export type UPDATE_ROUTE_STARTED_TYPE = {
  type: 'UPDATE_ROUTE_STARTED',
  payload: Object
};
export const UPDATE_ROUTE_STARTED = 'UPDATE_ROUTE_STARTED';

export type CREATE_ROUTE_SUCCESS_TYPE = {
  type: 'CREATE_ROUTE_SUCCESS',
  payload: ROUTE_TYPE
};
export const CREATE_ROUTE_SUCCESS = 'CREATE_ROUTE_SUCCESS';

export type SORT_ROUTE_STOP_STARTED_TYPE = {
  type: 'SORT_ROUTE_STOP_STARTED',
  payload: {
    routeId: number,
    stopId: number,
    index: number
  }
};
export const SORT_ROUTE_STOP_STARTED = 'SORT_ROUTE_STOP_STARTED';

export type DELETE_ROUTE_STARTED_TYPE = {
  type: 'DELETE_ROUTE_STARTED',
  payload: {
    routeId: number,
  }
};
export const DELETE_ROUTE_STARTED = 'DELETE_ROUTE_STARTED';

export type DELETE_ROUTE_SUCCESS_TYPE = {
  type: 'DELETE_ROUTE_SUCCESS',
  payload: {
    id: string
  }
};
export const DELETE_ROUTE_SUCCESS = 'DELETE_ROUTE_SUCCESS';

export type SORT_ROUTE_STOP_SUCCESS_TYPE = {
  type: 'SORT_ROUTE_STOP_SUCCESS',
  payload: ROUTE_TYPE
};
export const SORT_ROUTE_STOP_SUCCESS = 'SORT_ROUTE_STOP_SUCCESS';

export type SCHOOL_ROUTES_FETCH_STARTED_TYPE = {
  type: 'SCHOOL_ROUTES_FETCH_STARTED',
  payload: {
    schoolId: number,
    text?: string
  }
};
export const SCHOOL_ROUTES_FETCH_STARTED = 'SCHOOL_ROUTES_FETCH_STARTED';

export type DELETE_ROUTE_STOP_STUDENT_STARTED_TYPE = {
  type: 'DELETE_ROUTE_STOP_STUDENT_STARTED',
  payload: {
    studentId: number,
    routeStopId: number
  }
};
export const DELETE_ROUTE_STOP_STUDENT_STARTED = 'DELETE_ROUTE_STOP_STUDENT_STARTED';

export type DELETE_ROUTE_STOP_STUDENT_SUCCESS_TYPE = {
  type: 'DELETE_ROUTE_STOP_STUDENT_SUCCESS',
  payload: number
};
export const DELETE_ROUTE_STOP_STUDENT_SUCCESS = 'DELETE_ROUTE_STOP_STUDENT_SUCCESS';

export type DELETE_ROUTE_STOP_STUDENT_FAILED_TYPE = {
  type: 'DELETE_ROUTE_STOP_STUDENT_FAILED',
  payload: ERROR_TYPE
};
export const DELETE_ROUTE_STOP_STUDENT_FAILED = 'DELETE_ROUTE_STOP_STUDENT_FAILED';

export type ROUTE_TO_DELETE_TYPE = {
  type: 'ROUTE_TO_DELETE',
  payload: ID_TYPE
};
export const ROUTE_TO_DELETE = 'ROUTE_TO_DELETE';

export const GOING_ROUTE_TYPE = 'going';
export const RETURNING_ROUTE_TYPE = 'returning';


export type ROUTES_ACTION_TYPE =
  | ROUTES_FETCH_STARTED_TYPE
  | UPDATE_STOP_WEEKDAYS_TYPE
  | DELETE_ROUTE_STOP_STUDENT_FAILED_TYPE
  | DELETE_ROUTE_STOP_STUDENT_SUCCESS_TYPE
  | ROUTES_UPDATE_SUCCEED_TYPE
  | DELETE_ROUTE_STOP_STUDENT_STARTED_TYPE
  | UPDATE_VISIBLE_ROUTES_TYPE
  | DELETE_ROUTE_STARTED_TYPE
  | SCHOOL_ROUTES_FETCH_STARTED_TYPE
  | DELETE_ROUTE_SUCCESS_TYPE
  | ROUTES_FETCH_SUCCEED_TYPE
  | SORT_ROUTE_STOP_SUCCESS_TYPE
  | SORT_ROUTE_STOP_STARTED_TYPE
  | ROUTES_FETCH_FAILED_TYPE
  | CREATE_ROUTE_STARTED_TYPE
  | ROUTE_FETCH_STARTED_TYPE
  | ROUTE_FETCH_SUCCEED_TYPE
  | ROUTE_FETCH_FAILED_TYPE
  | ROUTE_DESELECTED_TYPE
  | ROUTE_SELECTED_TYPE
  | ROUTE_REMOVED_TYPE
  | ROUTE_STUDENT_DESCRIPTION_FETCH_SUCCEED_TYPE
  | ROUTE_STUDENT_DESCRIPTIONS_ADDED_TYPE
  | ROUTE_STOPS_FETCH_STARTED_TYPE
  | ROUTE_STOPS_FETCH_SUCCEED_TYPE
  | ROUTE_STOPS_FETCH_FAILED_TYPE
  | ROUTE_UPDATED_TYPE
  | ROUTE_STOP_SELECTED_TYPE
  | ROUTE_STOP_UPDATED_TYPE
  | ROUTE_STOP_CONFIRMED_TYPE
  | ROUTE_PATH_FETCH_STARTED_TYPE
  | ROUTE_STOPS_DESELECTED_TYPE
  | ROUTE_STOPS_DETAIL_SHOWN_TYPE
  | ROUTE_STOPS_DETAIL_HIDDEN_TYPE
  | ROUTE_STOP_ADDED_TYPE
  | ROUTE_STOP_REMOVED_TYPE
  | ROUTE_STOP_STUDENTS_FETCH_STARTED_TYPE
  | ROUTE_STOP_STUDENTS_FETCH_SUCCEED_TYPE
  | ROUTE_STOP_STUDENTS_FETCH_FAILED_TYPE
  | ROUTE_STOP_FETCH_STARTED_TYPE
  | ROUTE_STOP_FETCH_SUCCEED_TYPE
  | ROUTE_STOP_FETCH_FAILED_TYPE
  | ROUTE_STOP_STUDENT_ADDED_TYPE
  | ROUTE_STOPS_STUDENT_ASSIGN_STARTED_TYPE
  | ROUTE_STOPS_STUDENT_ASSIGN_COMPLETED_TYPE
  | ROUTE_STOPS_STUDENT_ASSIGN_FAILED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/routes.js